import { Tag as AntdTag } from "antd";
import styled from "styled-components";
export const Tag = styled(AntdTag)`
  border-radius: ${(props) => props.theme.border.radius};
`;
